// The four pillars of the /tour-all onboarding intro (sidebar nav anchors, in tour order).
// Identification is textual everywhere (snippet label prefixes, section tags); all tour visuals
// use the theme accent — the old hue-rotated per-pillar palette is gone.

export type PillarId = "save" | "grow" | "share" | "match";

export const PILLARS_META: ReadonlyArray<{ id: PillarId; anchor: string }> = [
  { id: "save", anchor: "nav.save" },
  { id: "grow", anchor: "nav.grow" },
  { id: "share", anchor: "nav.share" },
  { id: "match", anchor: "nav.match" },
];
